export default __webpack_public_path__ + "static/media/prevencion.44717752.png";